import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * LEGACY: Appointments feature configuration.
 */
export const schema = z
  .object({
    enabled: z
      .boolean()
      .describe(
        'LEGACY: Enable/disable the appointments feature for clients at this level. When enabled, the appointments feature will be available in the Portal.'
      )
      .optional(),
    ref_num_label: z.string().describe('LEGACY: Reference number label within the appointments feature.').optional(),
    notificationEmail: z
      .string()
      .email()
      .describe('LEGACY: Email address that receives appointment notifications and alerts.')
      .optional(),
  })
  .strict()
  .describe('LEGACY: Appointments feature config. For new scheduling, see Appointment Management.');

export type Appointments = z.infer<typeof schema>;

export const definition = define({
  key: 'appointments',
  schema,
  label: 'Appointments',
  description: 'LEGACY: Appointments feature config. For new scheduling, see Appointment Management.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.APPOINTMENTS.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: {
    enabled: false,
    ref_num_label: 'Reference ID',
    notificationEmail: '',
  },
  deprecated: true,
});
